import { useLOB, useLocale } from '@scfhp-web/shared-module';
import { getDropdownLinks } from 'utils/get-dropdown-links';
import { useCoverageStatus } from 'hooks/use-coverage-status.hook';

export const useUserDropdownConfig = (handleDeleteAccount: () => void) => {
  const { language } = useLocale();
  const lob = useLOB();
  const hasActiveCoverage = useCoverageStatus();

  return getDropdownLinks(language, lob, handleDeleteAccount, {
    hideFormsLink: !hasActiveCoverage,
  });
};
